import script from "./ListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ListView.vue?vue&type=script&setup=true&lang=js"

import "./ListView.vue?vue&type=style&index=0&id=962e040c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-962e040c"]])

export default __exports__